import * as React from "react";
import { useLayoutEffect, forwardRef } from "react";
import { Input } from "react-ui";

import { InternalIcon } from "../../../../Icons/Icon";
import { WIDTH_CONTROL_IN_HEADER } from "../../Common/Styles/PicklistModal.styles";

export const SearchInput = forwardRef<Input, { searchValue: string; onSearchValueChange: (value: string) => void }>(
    ({ searchValue, onSearchValueChange }, parentRef) => {
        useLayoutEffect(() => {
            const notCallbackRef = typeof parentRef !== "function";
            if (parentRef && notCallbackRef) {
                parentRef.current?.focus();
            }
        }, []);

        return (
            <Input
                data-tid="SearchInput"
                leftIcon={<InternalIcon name="SearchLoupeIcon" />}
                ref={parentRef}
                value={searchValue}
                width={WIDTH_CONTROL_IN_HEADER}
                onValueChange={onSearchValueChange}
            />
        );
    }
);

SearchInput.displayName = "SearchInput";
